import { h } from 'preact';

export default function PosIcon() {
  return <svg viewBox="0 0 20 20">
    <path
      d="M17.813 3.75H6.405a.157.157 0 0 0-.156.156V5c0 .086.07.156.156.156h11.407c.085 0 .156-.07.156-.156V3.906a.157.157 0 0 0-.157-.156zm0 5.547H6.405a.157.157 0 0 0-.156.156v1.094c0 .086.07.156.156.156h11.407c.085 0 .156-.07.156-.156V9.453a.157.157 0 0 0-.157-.156zm0 5.547H6.405A.157.157 0 0 0 6.25 15v1.094c0 .086.07.156.156.156h11.407c.085 0 .156-.07.156-.156V15a.157.157 0 0 0-.157-.156zM2.03 4.454a1.094 1.094 0 1 0 2.187 0 1.094 1.094 0 0 0-2.187 0zm0 5.546a1.094 1.094 0 1 0 2.188 0 1.094 1.094 0 0 0-2.188 0zm0 5.547a1.094 1.094 0 1 0 2.187 0 1.094 1.094 0 0 0-2.187 0z"
      />
  </svg>

    ;
}
